import React from 'react';
// Basic Components
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "OnlineInstore";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3">
                <SelectInput
                    name={componentName + "BranchOption"}
                    fullWidth={true}
                    defaultValue={props.loggedBranch}
                    label={LOOKUP.report.common.branch + "*"}
                    floatingLabelText={LOOKUP.report.common.branch + "*"}
                    hintText={LOOKUP.report.common.branch + "*"}
                    options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5">
            <AutoCompleteInput
                    name={`${componentName}ProductId`}
                    label="Search an existing product"
                    hintText="Product"
                    className={"AutoCompleteInput-searchbar"}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-xs-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                    disabled={props.disabled}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                    disabled={props.disabled}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
